<template>
    <div class="about__box-text">
        <p class="about__text">
            <b>{{
                getTranslatedText(`[ball] Banker`, {
                    ball: 1,
                })
            }}</b>
            {{ getTranslatedText('is played by selecting a single number out of 90') }}
        </p>
        <p class="about__text">
            {{ getTranslatedText(`Total stake = Single stake amount X 89`) }}
        </p>
        <p class="about__text">
            <b>{{ getTranslatedText(`Winning calculation`) }}</b>
        </p>
        <p class="about__text">
            {{
                getTranslatedText(`[odd] X Single stake`, {
                    odd: 960,
                })
            }}
        </p>
    </div>
</template>
<script>
import languageMixins from '@/mixins/language-mixins';

export default {
    mixins: [languageMixins],
};
</script>
